import script from "./SiteTandCsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SiteTandCsModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__